import React from "react";
import { Heading } from "../../Heading";
import { ContainerFW, } from "../../global";
import { VPSProviderCard, } from "./VPSproviderCard/VPSproviderCard";
export const VPSproviderCardDeck = ({ title, providerData: { logoUrl, logoAlt, keyFeatures, specifications, linkText, linkUrl, warning, openInNewTab }, }) => (React.createElement(ContainerFW, null,
    React.createElement("div", { className: "vps-provider-card-deck" },
        React.createElement(Heading, { design: "h2-regular" }, title),
        React.createElement("div", { className: "vps-provider-card-deck__cards" },
            React.createElement(VPSProviderCard, { logoUrl: logoUrl, logoAlt: logoAlt, keyFeatures: keyFeatures, specifications: specifications, linkText: linkText, linkUrl: linkUrl, warning: warning, openInNewTab: openInNewTab })))));
